// components/SEOHead.js
// ✅ Import karo aur EVERY page me use karo

import { useEffect } from "react";

const SEOHead = ({
  title,
  description,
  keywords,
  canonicalPath = "",
  ogImage = "https://decorhub-ruddy.vercel.app/og-image.jpg",
  schema = null,
}) => {
  useEffect(() => {
    // Title
    document.title = title;

    const setMeta = (name, content, isProperty = false) => {
      const selector = isProperty
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(isProperty ? "property" : "name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    // Standard meta
    setMeta("description", description);
    setMeta("keywords", keywords);

    // Open Graph
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:image", ogImage, true);
    setMeta("og:url", `https://decorhub-ruddy.vercel.app${canonicalPath}`, true);

    // Twitter
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://decorhub-ruddy.vercel.app${canonicalPath}`;

    // Dynamic Schema
    if (schema) {
      const existingSchema = document.getElementById("dynamic-schema");
      if (existingSchema) existingSchema.remove();
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "dynamic-schema";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalPath, ogImage, schema]);

  return null;
};

export default SEOHead;


// ============================================================
// HOW TO USE — paste this in your page components:
// ============================================================

/*
// In Home page (App.js or pages/Home.js):
import SEOHead from "../components/SEOHead";

function Home() {
  return (
    <>
      <SEOHead
        title="Best Event Decorators Near Me in Raipur, Chhattisgarh | DecorHub"
        description="Find & book the best event decorators near you in Raipur, CG. Wedding, birthday, corporate decoration — compare prices & book instantly on DecorHub."
        keywords="best decorators near me, event decorators Raipur, wedding decorators Chhattisgarh, birthday decoration Raipur CG"
        canonicalPath="/"
      />
      // ... rest of your component
    </>
  );
}


// In Decorators listing page:
import SEOHead from "../components/SEOHead";

function Decorators() {
  const category = new URLSearchParams(window.location.search).get("category");
  const city = new URLSearchParams(window.location.search).get("city");

  const getTitle = () => {
    if (category === "wedding") return "Best Wedding Decorators in Raipur CG | DecorHub";
    if (category === "birthday") return "Birthday Party Decorators Near Me Raipur CG | DecorHub";
    if (city) return `Top Event Decorators in ${city} Chhattisgarh | DecorHub`;
    return "Top Event Decorators in Raipur Chhattisgarh | DecorHub";
  };

  return (
    <>
      <SEOHead
        title={getTitle()}
        description="Browse 100+ verified event decorators in Raipur, Bilaspur, Durg, Bhilai CG. Compare prices & book the best decorator for your event."
        keywords="decorators in Raipur, event decorators CG, wedding decorators near me, party decorators Chhattisgarh"
        canonicalPath={`/decorators${window.location.search}`}
      />
      // ... rest of your component
    </>
  );
}


// In Decorator Profile page:
import SEOHead from "../components/SEOHead";

function DecoratorProfile({ decorator }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": decorator.name,
    "description": decorator.bio,
    "image": decorator.photos?.[0],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": decorator.city,
      "addressRegion": "Chhattisgarh",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": decorator.rating,
      "reviewCount": decorator.reviewCount
    }
  };

  return (
    <>
      <SEOHead
        title={`${decorator.name} - Best Event Decorator in ${decorator.city} CG | DecorHub`}
        description={`Book ${decorator.name}, top-rated event decorator in ${decorator.city}, Chhattisgarh. ${decorator.bio?.slice(0, 120)}...`}
        keywords={`${decorator.name}, decorator ${decorator.city}, event decorator ${decorator.city} CG`}
        canonicalPath={`/decorators/${decorator._id}`}
        ogImage={decorator.photos?.[0]}
        schema={schema}
      />
      // ... rest of your component
    </>
  );
}
*/
